import { ApiKey, ApiPathManager } from "app/shared/services/api-path";
import { getDataHeaders, getUserHeader, getUserParam } from "app/shared/services/header-builder";
import { REQUESTINPUT } from "app/shared/services/services-model.type";
import { instance } from "app/shared/util/token-store";
import { nonAccentVietnamese, replaceEnterKey, replaceSpace } from "app/shared/util/validate";
import {
  DataBillingCreate,
  FetchBillingAuthorizationRequest,
  FetchBillingConfirmRequest,
  FetchBillingPackageRequest,
} from "../reducer/types";

const createParam = (dataCreate: DataBillingCreate): REQUESTINPUT => {
  const description =
    "TT hoa don " + replaceEnterKey(replaceSpace(nonAccentVietnamese(dataCreate.SERVICE?.label.trim()))) + " cho MAKH/SDT/HD";
  const params: REQUESTINPUT = {
    USERPROFILE: getUserHeader(),
    ACCOUNTPROFILE: {
      ACCOUNTNO: dataCreate.ACCOUNT_DEBIT?.ACCOUNTNO,
      ACCOUNTTYPE: dataCreate.ACCOUNT_DEBIT?.ACCOUNTTYPE,
    },
    EBINQUIRY: {
      SERVICE_CODE: dataCreate.SERVICE?.value,
      INQUIRY_CODE: dataCreate.INQUIRY_CODE,
      PROVIDER_CODE: dataCreate.PROVIDER?.value,
    },
    TRANSFER: {
      SERVICE_CODE: dataCreate.SERVICE_CODE,
      DEBIT_ACCOUNT_NUMBER: dataCreate.ACCOUNT_DEBIT?.ACCOUNTNO,
      DEBIT_ACCOUNT_TYPE: dataCreate.ACCOUNT_DEBIT?.ACCOUNTTYPE,
      TRANSACTION_DESCRIPTION: description + " " + dataCreate.INQUIRY_CODE,
      USERPROFILE: { ...getUserParam(), SPECIAL_FIELD8: dataCreate.PACKAGE?.value || "" },
    },
  };
  return params;
};

const confirmParam = (action: FetchBillingConfirmRequest): REQUESTINPUT => {
  const params: REQUESTINPUT = {
    USERPROFILE: getUserHeader(),
    EBINQUIRY: action.payload?.EBINQUIRY,
    TRANSFER: {
      ...action.payload?.TRANSFER,
      USERPROFILE: getUserHeader(),
    },
  };
  return params;
};

const authParam = (action: FetchBillingAuthorizationRequest): REQUESTINPUT => {
  const params: REQUESTINPUT = {
    AUTHORIZE_CODE: action.code,
    CHALLENGE_ID: action.payload?.CHALLENGE_ID,
    USERPROFILE: getUserHeader(),
    EBINQUIRY: action.payload?.EBINQUIRY,
    TRANSFER: {
      RQSTSEQ: action.payload?.TRANSFER?.RQSTSEQ || "",
      USERPROFILE: getUserParam(),
    },
  };
  return params;
};

export const fetchBillingInfoService = async () => {
  const { action, massageID, url } = ApiPathManager(ApiKey.PAYMENT_BILLING_INFO);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchBillingCreateService = async (dataCreate: DataBillingCreate) => {
  const params: REQUESTINPUT = createParam(dataCreate);
  const { action, massageID, url } = ApiPathManager(ApiKey.PAYMENT_BILLING_CREATE);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    ...params,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

// Xác nhận chuyển tiền
export const fetchBillingConfirmService = async (actionRq: FetchBillingConfirmRequest) => {
  const params: REQUESTINPUT = confirmParam(actionRq);
  const { action, massageID, url } = ApiPathManager(ApiKey.PAYMENT_BILLING_CHECK_INFO);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    ...params,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchBillingAuthService = async (actionRq: FetchBillingAuthorizationRequest) => {
  const params: REQUESTINPUT = authParam(actionRq);
  const { action, massageID, url } = ApiPathManager(ApiKey.PAYMENT_BILLING_AUTHORIZE_INFO);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    ...params,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

/** Lấy thông tin gói dịch vụ */
export const fetchBillingPackageService = async (actionRq: FetchBillingPackageRequest) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.PAYMENT_BILLING_INFO_PACKAGE);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: {
      ...userProfile,
      SPECIAL_FIELD10: actionRq.payload?.PROVIDER?.value,
      SPECIAL_FIELD9: actionRq.payload?.SERVICE?.value,
    },
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};
